import React from 'react';
import PatientsManagement from '../components/PatientsManagement';

const PatientsPage = () => <PatientsManagement />;

export default PatientsPage;
